import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const DAYS = [
  { id: 'mon', label: 'Monday' },
  { id: 'tue', label: 'Tuesday' },
  { id: 'wed', label: 'Wednesday' },
  { id: 'thu', label: 'Thursday' },
  { id: 'fri', label: 'Friday' },
  { id: 'sat', label: 'Saturday' },
  { id: 'sun', label: 'Sunday' },
];

const SLOTS = [
  { id: 'morning', label: 'Morning' },
  { id: 'day', label: 'Day' },
  { id: 'evening', label: 'Evening' },
  { id: 'night', label: 'Night' },
];

export default function WeekAvailabilityGrid({
  schedule = [],
  ariaLabel = 'Weekly availability',
  className = '',
  editing = false,
  onSlotToggle,
}) {
  const scheduleByDay = React.useMemo(() => {
    const map = {};
    (schedule || []).forEach((entry) => {
      if (entry && typeof entry.day === 'string') {
        map[entry.day.toLowerCase()] = Array.isArray(entry.slots) ? entry.slots.map((s) => String(s).toLowerCase()) : [];
      }
    });
    return map;
  }, [schedule]);

  const classes = [
    'week-grid',
    editing ? 'week-grid--editing' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-label={ariaLabel}>
      <div className="week-grid__row week-grid__row--header">
        <div>Day</div>
        {SLOTS.map((slot) => (
          <div key={slot.id}>{slot.label}</div>
        ))}
      </div>

      {DAYS.map((day) => {
        const activeSlots = scheduleByDay[day.id] || [];
        const isOn = activeSlots.length > 0;
        const rowMod = isOn ? 'week-grid__row--on' : 'week-grid__row--off';

        return (
          <div key={day.id} className={`week-grid__row ${rowMod}`}>
            <div className="week-grid__day">
              {day.label}
            </div>
            {SLOTS.map((slot) => {
              const slotOn = activeSlots.includes(slot.id);
              const slotClass = `week-grid__slot${slotOn ? ' week-grid__slot--on' : ''}${editing ? ' week-grid__slot--editing' : ''}`;
              const content = slotOn ? slot.label : '—';

              if (editing) {
                return (
                  <button
                    key={slot.id}
                    type="button"
                    className={slotClass}
                    aria-pressed={slotOn}
                    aria-label={`${day.label} ${slot.label} — ${slotOn ? 'available' : 'unavailable'}`}
                    onClick={() => onSlotToggle?.(day.id, slot.id, slotOn)}
                  >
                    {content}
                  </button>
                );
              }

              return (
                <div key={slot.id} className={slotClass}>
                  {content}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

WeekAvailabilityGrid.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.shape({
    day: PropTypes.string,
    slots: PropTypes.arrayOf(PropTypes.string),
  })),
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  editing: PropTypes.bool,
  onSlotToggle: PropTypes.func,
};
